import { Pipe, PipeTransform } from "@angular/core";

import { FORM_TYPE } from "@app/models/registration-form";
import {
  ZEREZ_COMPATIBLE_FORM_TYPES,
  ZerezCompatibleFormType,
} from "@app/modules/common-steps/summary/components/zerez-summary/zerez-summary.component";

@Pipe({
  name: "zerezCompatibleFormType",
})
export class ZerezCompatibleFormTypePipe implements PipeTransform {
  transform(value: FORM_TYPE): ZerezCompatibleFormType {
    if (this.#isZerezCompatible(value)) {
      return value;
    } else {
      throw new Error("Invalid form type for Zerez compatibility");
    }
  }

  #isZerezCompatible(type: FORM_TYPE): type is ZerezCompatibleFormType {
    return ZEREZ_COMPATIBLE_FORM_TYPES.has(type as ZerezCompatibleFormType);
  }
}
